export const mapboxCrendetials = 'pk.eyJ1IjoidnVjaXR5IiwiYSI6ImNrbHMzODdhNzA2N3cyd28zdmk4djlxZXMifQ.Q0LWkHUifYfwPzdCXSxbXA';

export default mapboxCrendetials;
